import { render } from "./Menu.vue?vue&type=template&id=cfc8a2da&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=cfc8a2da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Renault\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc8a2da"]])

export default __exports__